import styled, { keyframes, css } from "styled-components";

interface TabProps {
  $isFirst?: boolean;
  $isLast?: boolean;
  $isActive?: boolean;
  $rounded?: boolean;
}

export const SubHeaderContainer = styled.div`
  background-color: #fff;
  padding: 0.45rem 1.2rem;
  margin: 0 -1.2rem 8px;
  width: calc(100% + 2.4rem);
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  border-radius: 0;
  border-bottom: 1px solid #ebebeb;
  position: relative;
  z-index: 50;
`

export const SectionName = styled.h2`
  font-size: 1rem;
  font-weight: 700;
  width: fit-content;
  padding-right: 1rem;
  margin-right: 1rem;
  border-right: 1px solid #EBEBEB;
`

export const LeftSide = styled.div`
  display: flex;
  align-items: center;
`

export const TabsDiv = styled.div`
  font-family: 'Inter', sans-serif;
  display: flex;
`

export const Tab = styled.div<TabProps>`
  border: 2px solid #ebebeb;
  padding: 7px 18px 7px 12px;
  color: ${props => props.$isActive ? '#0090D3' : '#696969'};
  font-weight: ${props => props.$isActive ? 700 : 400};
  user-select: none;
  display: flex;
  align-items: center;
  font-size: .72rem;
  cursor: pointer;
  background-color: ${props => props.$isActive ? '#E6F4FB' : 'transparent'};
  border-color: ${props => props.$isActive ? '#0090D3' : '#ebebeb'};
  border-radius: ${props => {
    if (props.$rounded) return '0 2rem 2rem 0';
    if (props.$isFirst) return '2rem 0 0 2rem';
    if (props.$isLast) return '0 2rem 2rem 0';
    return '0';
  }};
  margin-left: ${props => props.$isFirst ? '0' : '-2px'};
  position: relative;
  z-index: ${props => props.$isActive ? '1' : '0'};
  height: 2.1rem;
  box-sizing: border-box;
  white-space: nowrap;

  img {
    filter: ${props => props.$isActive ? 'grayscale(0)' : 'grayscale(1)'};
    height: .8rem;
    width: .8rem;
    object-fit: contain;
    flex-shrink: 0;
    margin-right: 0.4rem;
  }
`

export const RightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: center;
  position: relative;
  z-index: 55;
`

export const RefreshIconContainer = styled.div`
  cursor: pointer;
  margin-right: 10px;
  color: #0090D3;
  display: flex;
  align-items: center;
  transition: transform 0.3s ease;

  &:hover {
    transform: rotate(90deg);
  }

  &:active {
    transform: rotate(180deg);
  }
`;

export const OptionsButton = styled.div`
  border: 1px solid #0090D3;
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  user-select: none;
  color: #0090D3;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f0f8ff; 
  }
`;

export const ConfigButton = styled(OptionsButton)``;

export const ButtonCreate = styled.div`
  font-weight: bold;
  user-select: none;
  display: flex;
  gap: 0.4rem;
  height: 2rem;
  align-items: center;
  font-size: .72rem;
  padding: 0 0.9rem;
  color: #fff;
  cursor: pointer;
  background-color: #0090D3;
  border-radius: 2rem;
  position: relative;
  z-index: 10;
  pointer-events: auto;
  img{
    height: .8rem;
    margin-right: 0.4rem;
  }
`

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const RefreshIcon = styled.img<{ $spinning?: boolean }>`
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
  ${({ $spinning }) => $spinning ? css`animation: ${spin} 1s linear infinite;` : ''}
`

export const FilterWrapper = styled.div`
    position: relative;
`

export const FilterTypesDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const CompanyTypes = styled.div`
  font-size: .8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1.6px solid #B1B1B1;
  border-radius: .5rem;
  color: #B1B1B1;
  user-select: none;
  cursor: pointer;
  padding: .4rem .8rem;
  background-color: transparent;
  transition: all 0.12s ease;

  &:hover {
    border-color: #0090D3;
    color: #0090D3;
  }

  &.actived {
    color: #ffffff;
    border-color: #0090D3;
    font-weight: 600;
    background-color: #0090D3;
    box-shadow: 0 0 0 4px rgba(0,144,211,0.06);
  }
`